import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import type { GuidanceState } from '~/utils/guidanceTypes'
import { parseGuidanceTags } from '~/utils/guidanceTagParser'

/**
 * detailsMode controls how the details section behaves:
 *   'collapsible' (default) — Hide/Details toggle, auto-expands for warn/danger
 *   'locked'                — Details always visible, no toggle button
 *   'hidden'                — Details always hidden, no toggle button
 */
type DetailsMode = 'collapsible' | 'locked' | 'hidden'


export default /*#__PURE__*/_defineComponent({
  __name: 'GuidanceHelper',
  props: {
    state: { default: 'safe' },
    badgeState: { default: undefined },
    badgeType: { default: '' },
    summaryLine: { default: '' },
    badgeText: { default: '' },
    detailTitle: { default: '' },
    details: { default: '' },
    tip: { default: '' },
    expanded: { type: Boolean, default: undefined },
    detailsMode: { default: 'collapsible' },
    floating: { type: Boolean, default: false },
    subtle: { type: Boolean, default: false },
    replacements: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { state: GuidanceState, badgeState: GuidanceState, badgeType: string, summaryLine: string, badgeText: string, detailTitle: string, details: string, tip: string, expanded: boolean, detailsMode: DetailsMode, floating: boolean, subtle: boolean, replacements: Record<string, string> }



const userToggled = ref(false)
const internalExpanded = ref(false)

const hasDetails = computed(() =>
  props.state !== 'safe' && !!(props.detailTitle || props.details || props.tip)
)

const showToggle = computed(() =>
  hasDetails.value && props.detailsMode === 'collapsible'
)

const isExpanded = computed(() => {
  if (props.detailsMode === 'locked') return true
  if (props.detailsMode === 'hidden') return false
  if (!hasDetails.value) return false
  if (props.expanded !== undefined && !userToggled.value) {
    return props.expanded
  }
  if (userToggled.value) {
    return internalExpanded.value
  }
  return props.state === 'warn' || props.state === 'at' || props.state === 'danger'
})

watch(() => props.state, () => {
  userToggled.value = false
})

function toggle() {
  userToggled.value = true
  internalExpanded.value = !isExpanded.value
}

const stateTextClass = computed(() => {
  switch (props.state) {
    case 'warn':
    case 'at': return 'text-guidance-warn-text'
    case 'danger': return 'text-guidance-danger-text'
    case 'verified':
    case 'safe': return 'text-guidance-verified'
    default: return 'text-guidance-verified'
  }
})

const parsedDetailTitle = computed(() =>
  parseGuidanceTags(props.detailTitle, props.replacements)
)

const parsedSummary = computed(() =>
  parseGuidanceTags(props.summaryLine, props.replacements)
)

const parsedDetails = computed(() =>
  parseGuidanceTags(props.details, props.replacements)
)

const parsedTip = computed(() =>
  parseGuidanceTags(props.tip, props.replacements)
)

return { __sfc: true,props, userToggled, internalExpanded, hasDetails, showToggle, isExpanded, toggle, stateTextClass, parsedDetailTitle, parsedSummary, parsedDetails, parsedTip }
}

})